module.exports = __webpack_public_path__ + "img/point_festival_banner.59d7646c.jpg";